var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { Focusable } from "@/common/mixins/Focusable";
import { Savable } from '@/common/mixins/Savable';
import { EnumHelpers } from '@/common/mixins/EnumHelpers';
import TextAreaRow from '@/common/components/TextAreaRow.vue';
import ListRow from '@/common/components/ListRow.vue';
import HeaderControl from '@/common/components/HeaderControl.vue';
import RadioButtonRow from '@/common/components/RadioButtonRow.vue';
import TargetSummaryControl from '@/template/components/continuousReportSummary/controls/TargetSummaryControl.vue';
import OperationSummaryTablesControl from '@/template/components/continuousReportSummary/controls/OperationSummaryTablesControl.vue';
import { ContinuousReportSummaryResults } from '@/common/types/ContinuousReportSummaryResults';
import { ContinuousReportNotes } from '@/common/types/ContinuousReportNotes';
var ResultsView = /** @class */ (function (_super) {
    __extends(ResultsView, _super);
    function ResultsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.radioButtonKey = null;
        return _this;
    }
    ResultsView.prototype.mounted = function () {
        this.focusOnFirstTag("h1");
    };
    Object.defineProperty(ResultsView.prototype, "targetSummaries", {
        get: function () {
            return this.results.targetSummaries;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ResultsView.prototype, "operationTotalsCorrect", {
        get: function () {
            return this.results.operationTotalsCorrect;
        },
        set: function (value) {
            if (value && !this.results.operationTotalsCorrect && this.operationRevisionChanged) {
                if (confirm(this.$i18n.t("ContinuousReportSummary.Confirm.OperationTotalsRevision").toString())) {
                    this.results.revisedOperationTotals = [];
                    this.results.operationTotalsCorrect = value;
                }
                this.radioButtonKey = Date();
            }
            else if (!value) {
                this.results.revisedOperationTotals = this.results.computedOperationTotals.map(function (x) { return ({ operationType: x.operationType, operationCount: null, realizedCount: null, encounterCount: null }); });
                this.results.operationTotalsCorrect = value;
            }
            else {
                this.results.operationTotalsCorrect = value;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ResultsView.prototype, "operationRevisionChanged", {
        get: function () {
            var _this = this;
            return this.results.revisedOperationTotals.some(function (x) { return !_this.isNullOrUndefined(x.operationCount) || !_this.isNullOrUndefined(x.realizedCount) || !_this.isNullOrUndefined(x.encounterCount); });
        },
        enumerable: false,
        configurable: true
    });
    ResultsView.prototype.isNullOrUndefined = function (value) {
        return value == null || value == undefined;
    };
    Object.defineProperty(ResultsView.prototype, "showTargetSummaries", {
        get: function () {
            var _a;
            return ((_a = this.targetSummaries) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ResultsView.prototype, "showOperationTotals", {
        get: function () {
            var _a;
            return ((_a = this.results.computedOperationTotals) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b;
    __decorate([
        Prop({ type: Object, required: true }),
        __metadata("design:type", typeof (_a = typeof ContinuousReportSummaryResults !== "undefined" && ContinuousReportSummaryResults) === "function" ? _a : Object)
    ], ResultsView.prototype, "results", void 0);
    __decorate([
        Prop({ type: Object, required: true }),
        __metadata("design:type", typeof (_b = typeof ContinuousReportNotes !== "undefined" && ContinuousReportNotes) === "function" ? _b : Object)
    ], ResultsView.prototype, "notes", void 0);
    ResultsView = __decorate([
        Component({
            name: "ResultsView",
            components: {
                TextAreaRow: TextAreaRow,
                ListRow: ListRow,
                HeaderControl: HeaderControl,
                TargetSummaryControl: TargetSummaryControl,
                OperationSummaryTablesControl: OperationSummaryTablesControl,
                RadioButtonRow: RadioButtonRow
            }
        })
    ], ResultsView);
    return ResultsView;
}(Mixins(Focusable, Savable, EnumHelpers)));
export default ResultsView;
